// extracted by mini-css-extract-plugin
export default {"pannel_header":"Pannelheader_pannel_header__eEVOt","large":"Pannelheader_large__f+CWP","mode_alerts":"Pannelheader_mode_alerts__9gKu+"};